const loadScripts = (imports: Array<Promise<void>>) => {
    Promise.all(imports).then(() => {
        import(
            /* webpackChunkName: "wand" */
            /* webpackMode: "eager" */
            './app'
        );
    });
};

const polyfills = [];

// @ts-ignore
if (!window.IntersectionObserver) {
    polyfills.push(
        import(
            /* webpackChunkName: "intersection-observer" */
            /* webpackMode: "lazy" */
            // @ts-ignore
            'intersection-observer'
        ),
    );
}

if (!window.ResizeObserver) {
    polyfills.push(
        import(
            /* webpackChunkName: "resize-observer" */
            /* webpackMode: "lazy" */
            '@juggle/resize-observer'
        ).then((module) => {
            // @ts-ignore
            window.ResizeObserver = module.ResizeObserver;
        }),
    );
}

// Polyfill for structuredClone in browser environment
// Done to be able to run e2e tests in the electron browser
// Eventually can be reverted after updating Cypress version or changing the browser
if (typeof (window as any).structuredClone === 'undefined') {
    polyfills.push(
        new Promise<void>((resolve) => {
            (window as any).structuredClone = (value: any) =>
                JSON.parse(JSON.stringify(value));
            resolve();
        }),
    );
}

loadScripts(polyfills);
